module.exports = {"id":"236920","name":"Justin Kluivert","rating":"75","photo":"./data/images/photos/1/236920.png","club":{"name":"Ajax","logo":"./data/images/clubs/Ajax.png"},"positions":["AG","AD"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JustinKluivert0.json
// module id = 2268
// module chunks = 0